import React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import CommonButtons from "src/shared/components/CommonButtons";
import { ToastContainer } from "react-toastify";
import { useUserTheme } from "src/shared/utils/useUserTheme";

interface CategoryToolbarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  showDeleted: boolean;
  onShowDeletedChange: (show: boolean) => void;
  onAddCategory: () => void;
}

const CategoryToolbar: React.FC<CategoryToolbarProps> = ({ searchTerm, onSearchChange, showDeleted, onShowDeletedChange, onAddCategory }) => {

  const {fontClass, borderHighlight } = useUserTheme();
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
      onSearchChange(inputValue);
  };


  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-4 w-full sm:w-[95vw] lg:w-[88vw] min-h-[60px] py-[10px] px-5 rounded-lg items-center">
        <FormControlLabel control={<Checkbox checked={showDeleted} onChange={(e) => onShowDeletedChange(e.target.checked)} />} label="View deleted categories" />
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search by Category name"
          className={`w-full max-w-[350px] px-3 py-2.5 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
        />
        <CommonButtons className="w-44 h-10" label="ADD CATEGORY" onClick={onAddCategory} />
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover />
      </div>
  );
};

export default CategoryToolbar;
